import Message, {
  type Props as MessageProps,
} from '@decisiv/ui-components/lib/components/Message';
import styled from 'styled-components';

const ErrorMessageBanner = styled(Message)<MessageProps>`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 11px 15px;
  border-radius: 2px;
  border-left: 2px solid var(--Status-Danger-Medium, #ff4142);
  background: var(--Status-Danger-Light, #ffdfdf);

  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: pre-line;

  > * {
    min-width: 0;
  }
`;

export default ErrorMessageBanner;
